import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/website/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Todo App";
const frontMatter = {};
import Example from '@/examples/todo-app';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  return <Example />;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/examples/todo-app',
  {"filePath":"src/pages/examples/todo-app.mdx","timestamp":1760974640000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)